import React from "react";
import InquiryToCustomer from "@/src/types/Entities/InquiryToCustomer";
import InquiryToCustomerAppointmentBox from "./InquiryToCustomerAppointmentBox";
import InquiryToCustomerInformationAndDocuments from "./InquiryToCustomerInformationAndDocuments";
import InquiryToCustomerDecisionBox from "./InquiryToCustomerDecisionBox";
import { AbstractCase } from "@/src/types/Entities/AbstractCase";
import { Navigate } from "react-router";

type InquiryToCustomerBoxProps = {
  inquiryToCustomer: InquiryToCustomer;
  product: AbstractCase;
  updateInquiryToCustomer: (data: Partial<InquiryToCustomer>) => Promise<InquiryToCustomer>;
};

export default function InquiryToCustomerBox({ inquiryToCustomer, product, updateInquiryToCustomer }: InquiryToCustomerBoxProps) {
  switch (inquiryToCustomer.inquiryType) {
    case "appointment":
      return <InquiryToCustomerAppointmentBox inquiryToCustomer={inquiryToCustomer} product={product} updateInquiryToCustomer={updateInquiryToCustomer} />;
    case "decision":
      return <InquiryToCustomerDecisionBox inquiryToCustomer={inquiryToCustomer} product={product} updateInquiryToCustomer={updateInquiryToCustomer} />;
    case "link":
      return <Navigate to={`${inquiryToCustomer.linkUrl}`} />;
    default:
      return (
        <InquiryToCustomerInformationAndDocuments inquiryToCustomer={inquiryToCustomer} product={product} updateInquiryToCustomer={updateInquiryToCustomer} />
      );
  }
}
